// src/utils/userUtils.js

import { USER_ROLE_MANAGER, USER_ROLE_ANALYST } from './constants'; // eslint-disable-line no-unused-vars

export const getRoleName = (role) => {
    switch (role) {
      case 1: case 'member': case '1': return "Funcionário (Nível 1)";
      case 2: case 'manager': case '2': return "Gestor (Nível 2)";
      case 3: case 'analyst': case '3': return "Analista (Nível 3)";
      default: return "Desconhecido";
    }
};

/**
 * Verifica se o usuário está em período de férias HOJE.
 * Retorna true se estiver de férias (deve bloquear ações).
 */
export const isUserOnVacation = (userProfile) => {
    if (!userProfile) return false;
    
    // Se não estiver ativo (demitido/inativo), conta como bloqueado também
    if (userProfile.isActive === false) return true;
    
    // Se tiver a flag manual forçada
    if (userProfile.onVacation === true && !userProfile.vacationStart) return true;

    // Verificação por datas
    if (userProfile.vacationStart && userProfile.vacationEnd) {
        const now = new Date();
        
        // Converte Timestamp do Firebase ou String para Date
        const start = userProfile.vacationStart.seconds 
            ? new Date(userProfile.vacationStart.seconds * 1000) 
            : new Date(userProfile.vacationStart);
            
        const end = userProfile.vacationEnd.seconds 
            ? new Date(userProfile.vacationEnd.seconds * 1000) 
            : new Date(userProfile.vacationEnd);
        
        // Ajusta horas para comparar apenas o dia (Início 00:00, Fim 23:59)
        now.setHours(0,0,0,0);
        start.setHours(0,0,0,0);
        end.setHours(23,59,59,999);

        // Se hoje for maior/igual ao início E menor/igual ao fim -> ESTÁ DE FÉRIAS
        return now >= start && now <= end;
    }
    
    return false;
};